// ArticleCard Component
import React from "react";

const ArticleCard = ({title, description, link}) => {
    return (
        <div className="article-card">
            <div className="text-container">
                <h3 className="title">{title}</h3>
                <p className="description">{description}</p>
                <a href={link} className="more-link">Περισσότερα</a>
            </div>
        </div>
    );
};

export default ArticleCard;